<!-- tab selection start -->
<div class="support-content">
    <ul class="nav nav-tabs detailed-tabs relative page-sub-heading" role="tablist">
        @if (permissionModules.includes('LIVE')) {
<li class="nav-item" routerLinkActive="active">
            <a [routerLink]="['/live']" routerLinkActive="active" class="nav-link text-center mt-1" href="#live">
                <i class="fa fa-map-marker"></i> Live
            </a>
        </li>
}
        @if (permissionModules.includes('DASHBOARD') && !permissionModules.includes('AZUGA-DASHBOARD')) {
<li class="nav-item" routerLinkActive="active">
            <a class="nav-link text-center mt-1 ml-4" [routerLink]="['/dashboard/default']" routerLinkActive="active"
                role="tab" href="#dashboard">
                <i class="fa fa-microchip"></i> Devices
            </a>
        </li>
}
        <!-- <li class="nav-item" routerLinkActive="active" *ngIf="permissionModules.includes('SYSTEM-DASHBOARD')">
            <a class="nav-link text-center mt-1 ml-4" [routerLink]="['/dashboard/system-dashboard']"
                routerLinkActive="active" role="tab" href="#system">
                <i class="fa fa-th"></i> System
            </a>
        </li> -->
        @if (permissionModules.includes('AL-DASHBOARD')) {
<li class="nav-item" routerLinkActive="active">
            <a class="nav-link text-center mt-1" [routerLink]="['/dashboard/al-dashboard']" routerLinkActive="active"
                role="tab" href="#al">
                <i class="fa fa-line-chart"></i> AL
            </a>
        </li>
}
        <!-- <li class="nav-item" routerLinkActive="active" *ngIf="permissionModules.includes('EVENTS-DASHBOARD')">
            <a class="nav-link text-center mt-1" [routerLink]="['/dashboard/events-dashboard']" href="#events"
                routerLinkActive="active">
                <i class="fa fa-table"></i> Events Dashboard
            </a>
        </li> -->
        <!-- <li class="nav-item" routerLinkActive="active" *ngIf="permissionModules.includes('EV-DASHBOARD')">
            <a [routerLink]="['/dashboard/ev']" routerLinkActive="active" class="nav-link text-center mt-1" role="tab"
                href="#ev">
                <i class="fa fa-plug"></i> EV
            </a>
        </li> -->
        @if (permissionModules.includes('AZUGA-DASHBOARD')) {
<li class="nav-item" routerLinkActive="active">
            <a class="nav-link text-center mt-1 ml-4" [routerLink]="['/dashboard/azuga']" routerLinkActive="active"
                role="tab" href="#azuga-dashboard">
                <i class="fa fa-microchip"></i> Status
            </a>
        </li>
}
    </ul>
</div>